import React from 'react';

import { createTour, TourTooltipProps, Finished } from './createTour';

import shoutoutContext from './shoutoutContext';

export const createShoutout = ({
  storageName,
  showing,
}: {
  storageName: string;
  showing: 'once' | 'always';
}) => {
  const ShoutoutTour = createTour<true>({
    storageName: 'shoutouts-' + storageName,
    isFinalStep: () => true,
    showing,
  });

  type ShoutoutTooltipProps = Omit<TourTooltipProps<true>, 'forStep'> & {
    onClose?: () => void;
    children?: React.ReactNode;
  };

  const ShoutoutTooltip: React.FC<ShoutoutTooltipProps> = React.memo<ShoutoutTooltipProps>(
    function ShoutoutTooltip(props) {
      const { disabled } = React.useContext(shoutoutContext);

      return (
        <ShoutoutTour.Provider initialStep disabled={disabled} getNextStep={() => Finished}>
          <ShoutoutTour.Tooltip forStep {...props} onStepDone={props.onClose} />
        </ShoutoutTour.Provider>
      );
    },
  );

  return {
    Tooltip: ShoutoutTooltip,
    reset: () => ShoutoutTour.reset(),
    hasUserSeen: ShoutoutTour.hasUserSeenTour,
  };
};
